import React from 'react';
import {useSelector,useDispatch} from "react-redux";
import {IDiscountType} from "../../../interfaces/IDiscounts";
import {setDiscountType} from "../../../actions/Discounts.action";
import { IReduxAppState } from "../../../reducers";
import { useCurrencyState } from "../../../yoello-lib/modules/hooks/useCurrencyState";
import Styles from "../../../scss/discounts.module.scss";
import { useTranslation } from "react-i18next";
interface IDiscountTypeProps{
  isEdit:boolean
}
export function DiscountType({isEdit}:IDiscountTypeProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currency = useCurrencyState();
  const {selectedType} = useSelector((state:IReduxAppState) => state.discounts)
  function onClick(e:any,type:IDiscountType){
    e.stopPropagation();
    dispatch(setDiscountType(type))
  }
  return (
    <div className={Styles.discountsTypeContainer}>
      <div onClick={(e)=>onClick(e,IDiscountType.PERCENTAGE)} className={selectedType===IDiscountType.PERCENTAGE ? Styles.active:isEdit?Styles.Hide:undefined}>
        <p>{t("discounts.form.percentage")}</p>
      </div>
      <div onClick={(e)=>onClick(e,IDiscountType.VALUE)} className={selectedType===IDiscountType.VALUE ? Styles.active:isEdit?Styles.Hide:undefined}>
        <p>{t("discounts.form.value",{currency_symbol:currency.symbol})}</p>
        </div>
    </div>
  )
}
